export const GET_RESERVATIONS_ERROR = "redux_store:reservations.error.get";
export const ADD_RESERVATION_ERROR = "redux_store:reservations.error.post";
export const DELETE_RESERVATION_ERROR = "redux_store:reservations.error.delete";
export const UPDATE_RESERVATION_ERROR = "redux_store:reservations.error.patch";
export const CONFIRM_RESERVATION_ERROR = "redux_store:reservations.error.confirm";
export const CANCEL_RESERVATION_ERROR = "redux_store:reservations.error.cancel";
export const GET_RESERVATION_PAYMENT_ERROR = "redux_store:reservations.error.get_payment";



// WEBPACK FOOTER //
// ./src/errors/reservations.js